module.exports = __webpack_public_path__ + "img/SerialDummy.6a532008.png";